import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import {
  calcularManual,
  calcularPorSped,
  type EntradaCalculadoraManual,
  type Identificacao,
  type SimulacaoRegistrada,
} from '../servicos/calculadora';

/**
 * Cálculo é **mutação**, não consulta: cada envio é uma operação nova, com
 * rate limit próprio no servidor, e não deve ser refeito sozinho ao voltar o
 * foco da janela.
 *
 * A identificação entra como parâmetro da mutação, e não fica capturada no
 * hook: quem simula é dado de **cada** cálculo, e prendê-lo aqui recriaria no
 * V2 o mesmo defeito do V1 — preencher uma vez e seguir calculando.
 */

export function useCalculoManual(): UseMutationResult<
  SimulacaoRegistrada,
  Error,
  { entrada: EntradaCalculadoraManual; quem: Identificacao }
> {
  return useMutation({
    mutationFn: ({ entrada, quem }: { entrada: EntradaCalculadoraManual; quem: Identificacao }) =>
      calcularManual(entrada, quem),
    // Sem retry: um 400 de validação ou um 429 de rate limit não melhoram na
    // segunda tentativa automática — só consomem a cota do usuário.
    retry: false,
  });
}

export function useCalculoPorSped(): UseMutationResult<
  SimulacaoRegistrada,
  Error,
  { arquivos: readonly File[]; quem: Identificacao }
> {
  return useMutation({
    mutationFn: ({ arquivos, quem }: { arquivos: readonly File[]; quem: Identificacao }) =>
      calcularPorSped(arquivos, quem),
    retry: false,
  });
}
